import st from "@/styles/Ui.module.scss";
import {CircularProgress} from "@mui/joy";
import clsx from "clsx";

interface Props {
    transparent?:boolean
    className?:string
}

const LoginLoader:React.FC<Props> = ({transparent, className}) => {
    
    
    return (
        <div className={clsx(st.login_loader, transparent && st.transparent, className)}>
            <CircularProgress color={"success"}/>
        </div>
    )
}

export default LoginLoader